import { render, staticRenderFns } from "./ConfigureLimits.vue?vue&type=template&id=03512d03"
import script from "./ConfigureLimits.vue?vue&type=script&lang=js"
export * from "./ConfigureLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports